import type { SVGProps } from 'react';

const SvgShopifyLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 32 32" {...props}>
    <defs>
      <clipPath id="shopify-logo_svg__a">
        <path fill="none" strokeWidth={0} d="M0 0h32v32H0z" className="shopify-logo_svg__cls-2" />
      </clipPath>
    </defs>
    <path
      fill={props.color}
      d="m20.3 31.6 9.4-2s-3.4-23-3.4-23.1c0-.2-.2-.3-.3-.3S23.5 6 23.5 6s-1.7-1.7-1.9-1.8l-.2-.1-1.2 27.5ZM21.1 4s-.4.1-.9.3c-.6-1.6-1.5-3.1-3.3-3.1h-.2c-.5-.6-1.1-.9-1.6-.9-4.1 0-6 5.1-6.6 7.6-1.6.5-2.7.8-2.8.9-.9.3-.9.3-1 1.1 0 .6-2.4 18.3-2.4 18.3L20 31.5l1.2-27.6Zm-4.6 1.2v.2c-1 .3-2.1.6-3.1 1 .6-2.3 1.7-3.4 2.7-3.9.3.7.4 1.5.4 2.7m-1.6-3.8c.2 0 .4 0 .5.2-1.3.6-2.7 2.1-3.3 5.2-.8.3-1.6.5-2.5.8.7-2.3 2.3-6.1 5.2-6.1Zm.7 13.7s-1.1-.6-2.3-.6c-1.9 0-2 1.2-2 1.5 0 1.6 4.2 2.2 4.2 6s-1.9 4.9-4.5 4.9S6.4 25 6.4 25l.8-2.7s1.6 1.4 3 1.4c.7 0 1.2-.5 1.3-1.2 0-2.1-3.5-2.2-3.5-5.7s2.1-5.8 6.3-5.8 2.4.5 2.4.5L15.5 15Zm1.6-12.8c.9.1 1.5 1.1 1.9 2.3-.5.2-1 .3-1.5.5v-.3c0-1-.1-1.8-.4-2.4Z"
      className="shopify-logo_svg__cls-3"
      style={{
        clipPath: 'url(#shopify-logo_svg__a)',
      }}
    />
  </svg>
);

export default SvgShopifyLogo;
